module.exports = __webpack_public_path__ + "static/media/luminous-BG_bottom-right.b77d10c3.svg";